import { useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import OrderShopItem from '@entities/Order/ui/OrderShopItem/OrderShoItem'

import {
  OfflinePurchase,
  OfflinePurchasePosition,
  useSingleOfflinePurchaseQuery,
} from '@shared/generated'
import Wrapper from '@shared/ui/wrapper'

import OrderHeader from './OrderHeader'
import OrderSummary from './OrderSummary'

import styles from './styles.module.scss'



interface OrderOnlineProps {
  data: OfflinePurchase;
  isInitialOpen?: boolean;
}

export default function OrderShop ({ data, isInitialOpen }: OrderOnlineProps) {
  const [ isDetail, setIsDetail ] = useState(isInitialOpen ?? false)
  const [ wasOpened, setWasOpened ] = useState(isInitialOpen ?? false)

  useEffect(() => {
    if (isDetail && !wasOpened) {
      setWasOpened(true)
    }
  }, [ isDetail, wasOpened ])

  const { data: singleOfflineData, loading } = useSingleOfflinePurchaseQuery({
    variables: { singleOfflinePurchaseId: data.id as string },
    skip: !wasOpened,
    fetchPolicy: 'no-cache',
  })

  const handleDetailClick = () => {
    setIsDetail((prev) => !prev)
  }

  // Use positions from query result or from initial data
  const positions = singleOfflineData?.singleOfflinePurchase?.positions || data.positions

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <OrderHeader
          data={data}
          isDetail={isDetail}
          handleDetailClick={handleDetailClick}
        />

        {isDetail ? (
          loading ? (
            <SkeletonTheme>
              <Skeleton count={1} height={120} style={{ borderRadius: 16 }} />
            </SkeletonTheme>
          ) : positions && positions.length > 0 ? (
              <div className={styles.root__items}>
                {positions.map((el) => (
                  <OrderShopItem
                    key={el?.id}
                    data={el as OfflinePurchasePosition}
                  />
                ))}
              </div>
            ) : null
        ) : null}

        {isDetail && <OrderSummary data={data} />}
      </Wrapper>
    </div>
  )
}
